__turbopack_context__.v({
  "className": "aeonik_9f3345-module__Z58ZmG__className",
});
